/* eslint-disable */

<template>
  <div id="map"></div>
</template>
<script>
import './Control.FullScreen'
export default {
  mounted () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const lat = this.$store.getters.lat
    const lng = this.$store.getters.lng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type[0]
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName

    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH')

    var map = L.map('map', {
      fullscreenControl: true,
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom)

    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 1,
      title: name,
      riseOnHover: true
    })
    map.addLayer(marker)

    var marker2 = L.circleMarker(latlng, {
      'draggable': false,
      radius: 5,
      title: name,
      riseOnHover: true
    })
    // map.addLayer(marker2)

    var marker3 = L.circleMarker(latlng, {
      'draggable': false,
      radius: 10,
      title: name,
      riseOnHover: true
    })
    map.addLayer(marker3)

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>"

    var polygonLayer = r360.leafletPolygonLayer()
    map.addLayer(polygonLayer)
    L.control.layers(basemaps).addTo(map)
    L.control.scale().addTo(map)
    L.control.zoom({
      // zoomDelta: 0.01
    }).addTo(map)

    var travelOptions = r360.travelOptions()
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH')
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/')
    travelOptions.addSource(marker)
    travelOptions.setTravelTimes(seconds)
    travelOptions.setTravelType(type)
    r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
      polygonLayer.setStrokeWidth(pixel)
      polygonLayer.clearAndAddLayers(polygons, true)
    })
  },
  created () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName
  }
}
</script>

<style scoped>
#map{position:absolute;width:42.5%; height:50%; right:5%; top:10%;background:lightgrey}

.marker{border:none;cursor:pointer;height:56px;width:56px;background-image:url(../../../static/img/marker-icon.png);background-color:rgba(0,0,0,0)}
.leaflet-control-layers-toggle{background-image:url(../../../static/img/layers.png);width:36px;height:36px}.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/marker-icon-2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/marker-icon-2x.png);background-size:26px 260px}retina .leaflet-control-layers-toggle{background-image:url(../../../static/img/layers-2x.png);background-size:26px 26px}
.leaflet-default-icon-path{background-image:url(../../../static/img/marker-icon.png)}
.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/marker-icon-2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/marker-icon-2x.png);background-size:26px 260px}


.leaflet-default-icon-path {
  background-image:url(../../../static/img/marker-icon.png)
  }

.fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen.png); }
.leaflet-retina .fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen-2x.png); background-size: 26px 26px; }
/* one selector per rule as explained here : http://www.sitepoint.com/html5-full-screen-api/ */
.leaflet-container:-webkit-full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:-ms-fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-pseudo-fullscreen { position: fixed !important; width: 100% !important; height: 100% !important; top: 0px !important; left: 0px !important; z-index: 99999; }

.leaflet-container .leaflet-control-scale{font-size:11px}
.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-moz-box-sizing:content-box;box-sizing:content-box;background:#fff;background:rgba(255,255,255,0.5)}

</style>



// WEBPACK FOOTER //
// src/components/toolBox/mB2.vue